import { stopsByTimeSlotAndSequence } from './order.mapper';
import { OrderStatus } from '../enums/orderType.enum';
import { isOperationalStop } from '../stopBehaviour.type';

export const toOrdersTableProps = ({
  id, internalId, vehicles, shipperCompany, carrierCompany, name, startDate, endDate, creationDate,
  trackingToleranceWindowInMinutes, status, stops, actualTravelledDistanceInMeters, creationProblems,
}) => {
  const hasStops = stops && stops.length;
  const sortedStops = hasStops ? stops.sort(stopsByTimeSlotAndSequence) : stops;
  /*
   * The orders list shows first/last as the tour's From and To, which is a statement about where the
   * consignment is picked up and delivered - so it must be computed over operational stops only.
   * Otherwise a route whose first row is a waypoint advertises that waypoint as the tour's origin.
   * Untagged stops are all operational, so this is the full list as before.
   * Falls back to the unfiltered ends if an order somehow has no operational stop at all, rather
   * than blanking the From/To columns.
   */
  const operationalStops = hasStops ? sortedStops.filter(isOperationalStop) : sortedStops;
  const endpointStops = operationalStops && operationalStops.length ? operationalStops : sortedStops;
  const firstStop = hasStops ? endpointStops[0] : null;
  const lastStop = hasStops ? endpointStops[endpointStops.length - 1] : null;
  const lastReachedStop = status === OrderStatus.EXPIRED
    ? stops.filter((stop) => isOperationalStop(stop)
      && stop.actualArrival
      && stop.actualArrival.time
      && stop.actualArrival.time !== -1
      && stop.status).pop()
    : null;

  return {
    id,
    internalId,
    vehicles,
    shipperCompany,
    carrierCompany,
    name,
    startDate,
    endDate,
    creationDate,
    trackingToleranceWindowInMinutes,
    status,
    stops: sortedStops,
    firstStop,
    lastStop,
    lastReachedStop,
    actualTravelledDistanceInMeters,
    creationProblems,
  };
};
